import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';

// Components
import AppKitProvider from './components/AppKitProvider/AppKitProvider';
import App from './App.js';

// Store
import { store } from './store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <HelmetProvider>
        <AppKitProvider>
          <App />
        </AppKitProvider>
      </HelmetProvider>
    </Provider>
  </React.StrictMode>,
);
